import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { UserLocation } from '@dvm-monorepo/interfaces/keycloak';
import { inject } from '@angular/core';

export const selectedUserLocationResolver: ResolveFn<RedirectCommand | UserLocation> = (
    route: ActivatedRouteSnapshot
) => {
    const router = inject(Router);
    const userLocations = route.parent?.data['userLocations'] as UserLocation[];
    const locationId = route.paramMap.get('locationId');
    const selectedUserLocation = userLocations?.find(location => location.id === locationId);

    return selectedUserLocation ?? new RedirectCommand(router.parseUrl('/locations'));
};
